import QueryHandler from '../../utils/query-handler.js'
import AppURL from '../../config/url.js'

document.addEventListener('DOMContentLoaded', () => {
  renderBook()
})

function tmpl(book_code){
  return `<iframe src="${AppURL.storage}/${book_code}/index.html"></iframe>`
}

// width="100%" height="647"

function renderBook(){
  const player = tmpl(QueryHandler().book)

  const placeholder = document.querySelector('#reader')

  let range = document.createRange();
      range.selectNode(placeholder);

  const documentFragment = range.createContextualFragment(player);

  placeholder.appendChild(documentFragment);
}
